// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3ygA7","question":"Question_question__2RNyI","description":"Question_description__E_rvW"};